import { QueryClientProvider } from "@tanstack/react-query";

import { queryClient } from "../common/lib/queryClient";

import { Routes } from "@/app/Routes";
import { Head, Foot, MobileMenu, LocalStoragePolicyBanner } from "@/common/components";
import { Toaster } from "@/common/components/ui/toaster";
import { TooltipProvider } from "@/common/components/ui/tooltip";

const Root = ({ children }: { children: React.ReactNode }) => {
  return <div className="flex flex-col min-h-screen">{children}</div>;
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Root>
          <MobileMenu />
          <Head />
          <Routes />
          <Foot />
          <Toaster />
          <LocalStoragePolicyBanner />
        </Root>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
